/**
 * Implement Vuex Store Namespaced Modules
 * https://vuex.vuejs.org/guide/modules.html#namespacing
 * Add Namespace into modules to avoid Module Store Objects conflicts;
 */
const drawerStates = {
    toggleDrawer: false,
    showNotifications: false,
    showInbox: false,
    untoggleNestedMenus: false,
    showMiniAppPreview: false,
    showUserSettings: false,
    setCurrentUser: {},
    showMayaReminder: false,
};
const getters = {
    showNotifications(state) {
        return state.showNotifications;
    },
    showInbox(state) {
        return state.showInbox;
    },
    untoggleNestedMenus(state) {
        return state.untoggleNestedMenus;
    },
    showMiniAppPreview(state) {
        return state.showMiniAppPreview;
    },
    showUserSettings(state) {
        return state.showUserSettings;
    },
    setCurrentUser(state) {
        return state.setCurrentUser;
    },
    mayaReminder(state) {
        return state.showMayaReminder;
    },
};
const mutations = {
    // commit('navigation_drawer/toggleDrawer')
    toggleDrawer(state, toggle = true) {
        state.toggleDrawer = toggle;
    },
    showInbox(state, val = false) {
        state.showInbox = val;
    },
    showNotifications(state) {
        state.showNotifications = true;
    },
    hideNotifications(state) {
        state.showNotifications = false;
    },
    untoggleNestedMenus(state, val = false) {
        state.untoggleNestedMenus = val;
    },
    showMiniAppPreview(state) {
        state.showMiniAppPreview = true;
    },
    hideMiniAppPreview(state) {
        state.showMiniAppPreview = false;
    },
    showUserSettings(state) {
        state.showUserSettings = true;
    },
    hideUserSettings(state) {
        state.showUserSettings = false;
    },
    setCurrentUser(state, val = {}) {
        state.setCurrentUser = val;
    },
    showMayaReminder(state, val = false) {
        state.showMayaReminder = val;
    },
};
export default {
    namespaced: true,
    state: drawerStates,
    getters,
    mutations,
};
